// @flow
import * as React from 'react';
import classNames from 'classnames';

import IconCross from 'app/common/icons/IconCross';
import ConfirmationDialog from 'app/common/components/Confirmation/ConfirmationDialog';

import styles from './ECartItem.module.scss';;


type Props = {
  id: string | number,
  children: React.Node,
  onCrossClick?: (id: string | number) => void | Promise<any>,
  confirmationText?: string,
  className?: string,
}

const ECartItem = ({ id, children, onCrossClick, confirmationText, className }: Props) => {
  const handleCrossClick = React.useCallback((e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (typeof onCrossClick === 'function') {
      onCrossClick(id);
    }
  }, [onCrossClick, id]);

  return (
    <div className={classNames(styles.root, className)}>
      {children}
      {onCrossClick
        && (
          confirmationText
            ? <ConfirmationDialog
              onConfirm={handleCrossClick}
              text={confirmationText}
              confirmButtonText="Удалить"
              confirmButtonProps={{ error: true }}
            >
              {handleConfirm => (<a href="remove" onClick={handleConfirm}>
                <IconCross className={styles.iconCross} />
              </a>)}
            </ConfirmationDialog>
            : <a href="remove" onClick={handleCrossClick}>
              <IconCross className={styles.iconCross} />
            </a>
        )}
    </div>
  );
};

export default ECartItem;
